import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { NIGHTINGALE_BLACK } from '../colors';
import { height } from '../style/height';
import { width } from '../style/width';
var StyledSvg = styled.svg(_templateObject(), function (_ref) {
  var $height = _ref.$height;
  return $height && height($height);
}, function (_ref2) {
  var $width = _ref2.$width;
  return $width && width($width);
});

var Logo = function Logo(_ref3) {
  var _ref3$color = _ref3.color,
      color = _ref3$color === void 0 ? NIGHTINGALE_BLACK : _ref3$color,
      width = _ref3.width,
      height = _ref3.height,
      props = _objectWithoutPropertiesLoose(_ref3, ["color", "width", "height"]);

  return /*#__PURE__*/React.createElement(StyledSvg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 786.7 134.6",
    $height: height,
    $width: width
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M68.2,114.8c0,4,1.5,6.5,4.6,7.1l3.5,0.6c3.1,0.4,4,2.1,4,6.3v3.3H26.9v-3.3c0-4.2,1.2-6,3.8-6.3l3.3-0.6 c3.6-1.3,4.6-3.1,4.4-7.1V13.1h-7.7H29c-11.1,0-17.3,4.4-18.2,12.9l-0.4,2.9c-0.6,4.6-1.7,5.6-6.5,5.6H0V0c2.5,1.9,8.8,4,11.9,4H95 c3.1,0,9.2-2.1,11.5-4v34.4H102c-3.3,0-4.6-1.5-5.2-5.6l-0.4-2.9c-2.1-10-6.9-13.1-20.7-12.9h-0.6h-6.9V114.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M195.6,87.9c0,26.9-20.5,46.7-48.2,46.7c-27.8,0-48.2-20-48.2-47.6c0-26.3,20.5-45.7,48.6-45.7 S195.6,60.5,195.6,87.9z M130.4,87.4c0,25.2,6.1,38.2,17.7,38.2c10.9,0,16.5-11.7,16.5-35.1c0-26.1-6-40.1-17.3-40.1 C136.3,50.3,130.4,63.6,130.4,87.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M299.5,114.2c0,4.2,1.2,6,4.4,7.1l1.9,0.6c3.3,1,3.8,2.1,3.8,6.5v3.6h-38v-7.9c-4.4,4-5.8,5-7.7,6.1 c-4.4,2.5-11.7,4.2-18.6,4.2c-16.9,0-27.5-11.3-27.5-29.4v-44c0-4.6-0.4-5.2-4.4-7.1l-1.3-0.6c-4-1.5-4.4-2.1-4.4-6.5v-3.3 l38.8-1.2V106c0,9.6,4.2,15.7,11.1,15.7c4.8,0,10.6-2.7,13.2-6.1V61.2c0-4.4-1.2-6.1-4.4-7.1l-1.7-0.6c-3.3-1.2-3.8-2.1-3.8-6.5 v-3.3l38.6-1.2V114.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M361.1,69.7c1-1.7,1.5-3.1,1.9-3.6c5.2-10.2,7.1-13.2,10.9-17.1c4.8-5,10.2-7.7,15.6-7.7 c8.3,0,14.4,6.1,14.4,14.6c0,7.7-5.4,14-12.3,14c-3.5,0-6.1-1.3-9.2-5.2c-1.2-1.3-2.7-2.1-4.2-2.1c-6.1,0-14,19.2-14,34.6v17.7 c0,3.8,1.5,6.5,3.8,7.1l3.3,0.6c2.3,0.4,3.1,2.1,3.1,6.3v3.3h-49v-3.3c0-4.2,0.6-5.4,3.8-6.3l1.9-0.6c3.3-1.2,4.4-2.9,4.4-7.1V61.2 c0-4.2-1.3-6.3-4.4-7.1l-2.3-0.6c-2.7-0.8-3.5-2.3-3.5-6.5v-3.3l35.7-1.3V69.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M450.8,114.8c0,4.2,1.2,6,4.8,7.1l1.9,0.6c2.7,0.8,3.5,2.1,3.5,6.3v3.3h-49v-3.3c0-4.4,0.6-5.4,3.8-6.3 l1.9-0.6c3.3-1.2,4.4-2.9,4.4-7.1V21.3c0-4.2-1.2-6-4.4-7.1l-1.9-0.6c-3.3-1-3.8-1.9-3.8-6.5V4l38.8-1.3V114.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M568.9,121.7c0.8,1.2,1.2,1.9,1.2,2.5c0,4.6-9.8,9.8-18.4,9.8c-8.4,0-14.6-4.4-18.4-13.4 c-9,10.8-15.7,14-28.8,14c-18,0-30.3-10.4-30.3-25.5c0-12.1,7.5-20.7,23.4-26.9c5.2-2.1,5.8-2.1,30.5-7.7c-0.2-8.1-0.6-11.5-1.9-15 c-2.3-6-6.7-9.2-12.3-9.2c-4.8,0-8.3,2.3-8.3,5.6c0,0.6,0.2,1.5,0.4,2.7l0.2,3.3c0,6.7-5.4,11.5-12.7,11.5 C486,73.3,480,68,480,61.2c0-11.5,14.6-20,34.2-20c14.8,0,27.8,4.8,34.9,12.9c6.1,6.7,8.1,13.8,8.1,29.2v23.6c0,9,0,9.4,1.2,11.5 c0.8,1.7,2.1,2.7,3.6,2.7s3.3-0.8,4.6-2.5L568.9,121.7z M528.6,83.3c-14.8,2.3-23.4,11.3-23.4,24.4c0,8.6,4.6,15.4,10.2,15.4 c7.9,0,13.2-9.6,13.2-23.6V83.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M620.8,51.3c8.4-7.5,15.6-10.2,26.3-10.2c10.6,0,18.4,2.9,24,9c4.4,4.8,6.3,11.1,6.3,20.9v43.8 c0,4.2,1.2,6,4.4,7.1l1.9,0.6c3.3,1,3.8,2.1,3.8,6.3v3.3H639v-3.3c0-4.4,0.4-5,3.8-6.3l1.3-0.6c4-1.9,4.6-2.7,4.6-7.1V67.2 c0-8.6-4.2-13.2-12.1-13.2c-5.2,0-11.3,2.7-14.6,6.5v54.3c0,4,1.3,6.3,4.6,7.1l2.7,0.6c2.9,0.6,3.8,2.1,3.8,6.3v3.3h-49.9v-3.3 c0-4.2,0.6-5.4,3.8-6.3l1.9-0.6c3.3-1.2,4.4-2.9,4.4-7.1V61.2c0-4.4-1.2-6.1-4.4-7.1l-1.9-0.6c-3.3-1.2-3.8-2.1-3.8-6.5v-3.3 l37.4-1.3V51.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M728.1,86c0.4,25,9.8,38.4,26.5,38.4c9,0,15.6-3.8,25-14.8l7.1,6.1c-9.4,12.5-22.3,18.8-38.6,18.8 c-28.6,0-50.1-20.9-50.1-48.8c0-25.7,18.6-44.4,44.5-44.4c26.5,0,42.8,16.9,43.4,44.5H728.1z M757.7,76.4 c0-16.7-5.2-25.9-14.4-25.9c-9.2,0-14.6,9.2-15.2,25.9H757.7z"
  }));
};

export default Logo;